import React, {useEffect, useState} from 'react';
import AppText from "../../../../../../common/AppText";
import {t} from "../../../../../../../services/i18n";
import {HStack, Stack, VStack} from "native-base";
import SimpleInput from "../../../../../../common/SimpleInput";
import {Colors} from "../../../../../../../styles/Colors";
import {useDispatch, useSelector} from "react-redux";
import {isMobile} from "../../../../../../../services/Helpers";
import {GlobalStyleAttributes} from "../../../../../../../styles/GlobalStyles";
import {Radio} from "antd";
import {fetchApi} from "../../../../../../../services/HTTP";
import {updateBox} from "../../../../../../../redux/boxSlice";
import {store} from "../../../../../../../redux/store";
import {TRIAL_LIMIT_SETTING} from "../../../../../../../services/ConstHelper";
import {getCategoriesByTypes, toggleScheduleLoader, toggleSuccessFlag} from "../../../../../../../redux/ScheduleSlice";
import TrialLimitPerServiceType from "./TrialLimitPerServiceType";
import {buildTrialServiceTypeLimitsPayload} from "../../../../../../../services/Helpers";

const TrialLimit = (props) => {
    const { values, setFieldValue, errors, submitCount } = props;
    const shouldSave = useSelector((state) => state.schedule.settingsSaveFlag);
    const [radioSelection, setRadioSelection] = useState(null);
    const dispatch = useDispatch();
    const mobile = isMobile
    const fontSize = GlobalStyleAttributes.fonts.standard16

    useEffect(() => {
        if(shouldSave) {
            save()
        }
    }, [shouldSave]);

    useEffect(() => {
        let selection
        if(values.trialLimit === 'unlimited') {
            selection = 'unlimited'
        } else {
            selection = 'limited'
        }
        if(selection !== radioSelection) {
            setRadioSelection(selection)
        }
    }, [values.trialLimit]);

    const save = async () => {
        try {
            if (mobile) {
                dispatch(toggleScheduleLoader(true));
                const setting = {prop_name: TRIAL_LIMIT_SETTING, properties: {limit: values.trialLimit}}
                await fetchApi(`boxes/settings`, 'POST', setting, false, true);
                const rows = buildTrialServiceTypeLimitsPayload(values.trialServiceTypeLimits);
                await fetchApi('boxCategories/setTrialLimits', 'post', {rows}, false, true);
                await dispatch(getCategoriesByTypes(false));
                dispatch(toggleScheduleLoader(false));
                dispatch(toggleSuccessFlag(true))
                dispatch(updateBox({
                    settings: {
                        ...store.getState().box.box.settings,
                        [TRIAL_LIMIT_SETTING]: setting.properties
                    }
                }))
            }
        }catch(error) {
            console.log('error',error)
            dispatch(toggleScheduleLoader(false));
        }
    }

    const onRadioChange = (selected) => {
        if(selected === 'limited') {
            setFieldValue('trialLimit', 1)
        } else if(selected === 'unlimited') {
            setFieldValue('trialLimit', 'unlimited')
        }

        setRadioSelection(selected)
    }

    return (
        <VStack space={'2rem'}>
            <VStack space={'0.5rem'}>
                <Radio.Group onChange={(e) => onRadioChange(e.target.value)} value={radioSelection}>
                    <VStack space={'0.5rem'}>
                        <Radio value={'unlimited'}>
                            <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('trialLimitUnlimitedRadio')}</AppText>
                        </Radio>
                        <Radio value={'limited'}>
                            <Stack direction={isMobile ? 'column' : 'row'} space={'0.5rem'} alignItems={isMobile ? 'start' : 'center'}>
                                <AppText fontSize={fontSize}>{t('trialLimitBeforeTxt')}</AppText>
                                <HStack space={'0.5rem'} alignItems={'center'}>
                                    <SimpleInput value={values.trialLimit}
                                                 onChangeCallback={val => setFieldValue('trialLimit', val)}
                                                 width={'4rem'}
                                                 inputType={'float'}
                                                 status={errors.trialLimit ? 'error' : null}
                                    />
                                    <AppText fontSize={fontSize}>{t('trialLimitAfterTxt')}</AppText>
                                </HStack>
                            </Stack>
                        </Radio>
                    </VStack>
                </Radio.Group>
                {errors.trialLimit && <AppText fontSize={fontSize} color={Colors.error}>{errors.trialLimit}</AppText>}
            </VStack>
            <TrialLimitPerServiceType values={values} setFieldValue={setFieldValue} errors={errors} submitCount={submitCount}/>
        </VStack>
    );
};

export default TrialLimit;